import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { ReferralProgram } from "../types/view.referral";
import { fallback, formatCurrency, formatDate } from "../utils/formatters";

interface Props {
  data: ReferralProgram;
}

const getStatusStyles = (status?: string | null) => {
  const normalized = (status || "").toLowerCase();

  if (normalized === "upcoming") {
    return {
      backgroundColor: "#EEF2F6",
      color: "#55657D",
      label: "Upcoming",
    };
  }

  if (normalized === "completed") {
    return {
      backgroundColor: "#EEF2F6",
      color: "#55657D",
      label: "Completed",
    };
  }

  if (normalized === "cancelled") {
    return {
      backgroundColor: "#EEF2F6",
      color: "#55657D",
      label: "Cancelled",
    };
  }

  return {
    backgroundColor: "#EEF2F6",
    color: "#55657D",
    label: "N/A",
  };
};

export default function ReferralsTable({ data }: Props) {
  const referrals = data.referrals ?? [];

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "24px",
        p: 2.5,
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          alignItems: "center",
          mb: 2.5,
          flexWrap: "wrap",
        }}
      >
        <Typography sx={{ fontSize: "1rem", fontWeight: 600 }}>
          Referrals
        </Typography>

        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <Chip
            label="Upcoming N/A"
            sx={{
              borderRadius: "10px",
              backgroundColor: "#7B5648",
              color: "#fff",
            }}
          />
          <Chip
            label="Completed N/A"
            sx={{ borderRadius: "10px", backgroundColor: "#F3F5F8" }}
          />
          <Chip
            label="Cancelled N/A"
            sx={{ borderRadius: "10px", backgroundColor: "#F3F5F8" }}
          />
        </Box>
      </Box>

      {referrals.length === 0 ? (
        <Box
          sx={{
            borderRadius: "16px",
            p: 3,
            textAlign: "center",
            color: "#8A94A6",
          }}
        >
          No referral records available at the moment
        </Box>
      ) : (
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F3F5F8" }}>
              <TableCell>ID</TableCell>
              <TableCell>CLIENT</TableCell>
              <TableCell>DATE</TableCell>
              <TableCell>PACKAGE</TableCell>
              <TableCell>STATUS</TableCell>
              <TableCell>VALUE</TableCell>
              <TableCell>COMMISSION</TableCell>
              <TableCell>PAID</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {referrals.map((item) => {
              const status = getStatusStyles(item.status);

              return (
                <TableRow key={item.id}>
                  <TableCell>{fallback(item.id?.toString())}</TableCell>
                  <TableCell>{fallback(item.client)}</TableCell>
                  <TableCell>{formatDate(item.date)}</TableCell>
                  <TableCell>{fallback(item.package)}</TableCell>
                  <TableCell>
                    <Chip
                      label={status.label}
                      sx={{
                        backgroundColor: status.backgroundColor,
                        color: status.color,
                        borderRadius: "999px",
                      }}
                    />
                  </TableCell>
                  <TableCell>{formatCurrency(item.value)}</TableCell>
                  <TableCell>{formatCurrency(item.commission)}</TableCell>
                  <TableCell>{fallback(item.paid)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
}
